export const ChipDT = {
	chip: {
		css: ({ dt }) => `
          .p-chip-clickable:hover {
              cursor: pointer;
          }
          .p-chip-info {
              background-color: ${dt('highlight.background')};
          }
          .p-chip-white {
              background-color: ${dt('content.background')};
          }
          .p-chip-s {
              padding: var(--p-padding-xxs) 1rem;
              font-weight: 600;
              font-size: .75rem;
              line-height: 1rem;
              letter-spacing: 0;
              color: var(--p-text-muted-color);
              height: fit-content;
          }
        `,
	},
};
